export default __webpack_public_path__ + "static/media/Snd_LowerIDown.591b348f.mp3";